function ReceivedSmsDiv(props) {
    return (
      <>
        <div className={props.class}>
            <p>如遇以下特殊情況或許未能接收取貨連結短訊：</p>
            <ol>
                <li>登記預購電話號碼非本港手提電話號碼，接收訊息時間或會受影響；</li>
                <li>流動通訊服務供應商之訊息過濾服務、用戶安裝來電及訊息軟件過濾功能、使用一卡兩號未能接收短訊、用戶手機已關機或網絡信號接收不良等；</li>
                <li>網絡回報號碼因暫停服務或其他服務限制原因未能接收訊息。</li>
            </ol>
        </div>
      </>
    );
  }
  
export default ReceivedSmsDiv;